import React from 'react';
import PropTypes from 'prop-types';

const TickBox = ({
  value = 0,
  onChange,
  disabled,
  min = 0,
  max = null,
  disablePlus
}) => {
  return (
    <div className="swformfieldwrapper">
      <button
        className="swformfieldbtn"
        type="button"
        onClick={() => {
          onChange((value || 0) - 1);
        }}
        disabled={disabled || value <= min}
      >
        <i className="fa fa-minus" aria-hidden="true" />
      </button>
      <div className="swformfieldwrapper">
        <input
          className="swformfield__control"
          type="number"
          onChange={e => {
            let stringVal = e.target.value;
            if (stringVal == null || stringVal.trim() === '') {
              stringVal = min;
            }
            let newVal = parseInt(stringVal, 10);
            if (newVal <= min) {
              newVal = min;
            }
            if (max != null && max > min && newVal >= max) {
              newVal = max;
            }

            onChange(newVal);
          }}
          value={value || 0}
          disabled={disabled}
        />
      </div>
      <button
        className="swformfieldbtn"
        type="button"
        onClick={() => {
          onChange((value || 0) + 1);
        }}
        disabled={disabled || (max != null && value >= max) || disablePlus}
      >
        <i className="fa fa-plus" aria-hidden="true" />
      </button>
    </div>
  );
};

TickBox.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  disablePlus: PropTypes.bool
};

export default TickBox;
